export function HeadingOne({ children }: { children: React.ReactNode }) {
  return <h1 className="text-3xl font-bold text-default mb-2">{children}</h1>;
}
